export {};

Number.prototype.toCurrency = function(): string {
  return new Intl.NumberFormat('de-DE', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(this as number) + ' €';
};
